import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Trash2 } from "lucide-react";

export default function AdminGallery() {
  const [events, setEvents] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [eventId, setEventId] = useState("");
  const [caption, setCaption] = useState("");
  const [uploading, setUploading] = useState(false);

  const load = () => api.get("/gallery").then((r) => setGallery(r.data));
  useEffect(() => {
    api.get("/events").then((r) => { setEvents(r.data); if (r.data[0]) setEventId(r.data[0].id); });
    load();
  }, []);

  const upload = async (e) => {
    e.preventDefault();
    const file = e.target.file.files[0];
    if (!file || !eventId) return toast.error("Selecione evento e arquivo");
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("event_id", eventId);
      fd.append("caption", caption);
      await api.post("/gallery", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Imagem enviada");
      e.target.reset();
      setCaption("");
      load();
    } catch (err) { toast.error("Falha no upload"); }
    finally { setUploading(false); }
  };

  const del = async (id) => { if (!confirm("Excluir foto?")) return; await api.delete(`/gallery/${id}`); toast.success("Excluída"); load(); };

  return (
    <div className="space-y-6">
      <div><div className="label">Memórias</div><h1 className="font-display text-3xl sm:text-4xl font-black mt-2">Galeria</h1></div>
      <form onSubmit={upload} className="ci-card p-6 space-y-4" data-testid="admin-gallery-form">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="label">Edição</label>
            <select required value={eventId} onChange={(e)=>setEventId(e.target.value)} className="ci-input mt-1">
              {events.map((e) => <option key={e.id} value={e.id}>#{e.edition_number} — {e.name}</option>)}
            </select>
          </div>
          <div><label className="label">Legenda (opcional)</label><input value={caption} onChange={(e)=>setCaption(e.target.value)} className="ci-input mt-1"/></div>
        </div>
        <div><label className="label">Arquivo (JPG, PNG, WEBP)</label><input type="file" name="file" required accept="image/*" className="ci-input mt-1"/></div>
        <button type="submit" disabled={uploading} className="btn-primary disabled:opacity-50"><Upload size={16}/> {uploading ? "Enviando..." : "Enviar imagem"}</button>
      </form>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {gallery.map((g) => (
          <div key={g.id} className="relative group ci-card p-0 aspect-square overflow-hidden">
            <img src={fileUrl(g.storage_path)} alt="" className="w-full h-full object-cover" />
            <button onClick={()=>del(g.id)} data-testid={`admin-gallery-delete-${g.id}`} className="absolute top-2 right-2 bg-black/70 border border-red-500/40 text-red-300 p-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"><Trash2 size={14}/></button>
          </div>
        ))}
      </div>
    </div>
  );
}
